

































































import { Component, Vue } from 'vue-property-decorator'
import { CreateClassify, UpdateClassify, DeleteClassify, SaveClassifySort, QueryClassifyTree } from '@/api'
import { Message, MessageBox } from 'element-ui'
import { loadClassifyTree } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {VImageUpload},
})
export default class ClassifyList extends Vue {
  private data: Array<any> = []
  private classifyNameTemp = ''
  private classifyDescTemp = ''
  private isShow = 1
  private classifyTemp: any = {}
  private showAdd = false
  private showUpdate = false

  private fromData = {
    id: undefined,
    parentClassifyId: undefined,
    classifyName:undefined,
    classifyDesc:undefined,
    isShow:true,
    imageUrlList:[],
    imageUrl:"",
    sort:0,
  }

  private treeProps = {
    label: 'classifyName',
    children: 'child',
  }

  private async created() {
    this.loadData()
  }
  public async refreshCache() {
    const tree = await QueryClassifyTree({ isCleanCach: true })
  }
  public async loadData() {
    const tree = await loadClassifyTree()
    this.data = [tree]
  }
  // 节点拖拽成功是
  public async nodedrop() {
    await SaveClassifySort({ classifyTreeNode: this.data[0] })
    this.loadData()
  }
  // 判断是否可以拖动
  public async checkDrop(draggingNode: any, dropNode: any, type: string) {
    if (type == 'inner') {
      if (dropNode.data.parentClassifyId > 0) {
        // 目标节点不是顶级，不能插入
        return false
      } else if (draggingNode.data.child.length > 0) {
        // 子节点数量大于0 不能插入
        return false
      }
    }
    return true
  }
  public closeAdd() {
    this.classifyNameTemp = ''
    this.classifyDescTemp = ''
    this.isShow = 1;
    this.classifyTemp = {}
    this.showAdd = false
    this.loadData()
  }
  public async saveAdd() {
    await CreateClassify({
      parentClassifyId: this.classifyTemp.id,
      classifyName: this.classifyNameTemp,
      classifyDesc: this.classifyDescTemp,
      isShow: this.isShow,
      sort: this.classifyTemp.child.length,
    })
    this.closeAdd()
  }
  public closeUpdate() {
    this.classifyNameTemp = ''
    this.classifyDescTemp = ''
    this.isShow = 1
    this.classifyTemp = {}
    this.showUpdate = false
    this.loadData()
  }
  public async saveUpdate() {

     this.fromData.imageUrl = this.fromData.imageUrlList.map((e: any) => e.url).join(',')
    await UpdateClassify({
      id: this.classifyTemp.id,
      classifyName: this.classifyNameTemp,
      classifyDesc: this.classifyDescTemp,
      imageUrl: this.fromData.imageUrl,
      isShow: this.isShow,
    })
    this.closeUpdate()
  }
  public async createClassify(data: any,node: any) {
    this.classifyTemp = data
    this.showAdd = true
  }

  public async updateClassify(data: any) {
    this.classifyTemp = data

    console.log(data)
    this.classifyNameTemp = data.classifyName
    this.classifyDescTemp = data.classifyDesc
    this.isShow = data.isShow


    if(data.imageUrl){
      this.fromData.imageUrlList = data.imageUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.fromData.imageUrlList = []
    }
    console.log(this.isShow)
    this.showUpdate = true
  }

  private async copyId(data: any){
    console.log(data.id)
    this.$copyText(""+data.id).then(()=>{
      Message.success('复制成功')
    })
  }

  private changeIsShow(value: any){
    console.log(value)
    console.log(this.isShow)
  }

  public async deleteClassify(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteClassify({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
